import * as DKFDS from 'dkfds';
import $ from 'jquery';
import moment from 'moment';
import { convertHexStringToBitMask } from '../utils';

const acceptWhenModal = document.getElementById('acceptWhenModal');
if (acceptWhenModal) {
    new DKFDS.Modal(acceptWhenModal).show();
}

// Constants for 'Råderum'
const HELE_PERIODEN = '1';
const SPECIFIKT_TIDSRUM = '2';
const UDENFOR_SPAERRETID = '3';

// Constants for 'Afspærring'
const PERIODEVIS = '2';

// Selector constants
const CHECKBOXES = 'input:checkbox';

const weekDays = ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'];

let selectState, originFromRowIndex, originFromColumnIndex, dragInitiator;

function toRow(aMoment) {
    return aMoment.hour() * 2 + Math.floor(aMoment.minute() / 30);
}

function showSelect($select) {
    $select.closest('.form-group').show();
    $select.closest('.form-group').next('details').show();
}

function hideSelect($select) {
    $select.val('0').trigger('change').closest('.form-group').hide();
    $select.closest('.form-group').next('details').hide();
}

function colorBlockedDays($table, blocking, days, cols) {
    // The timestamps are converted to 0-based half-hour indices, so 00:00 = 0.
    // In the CSS selectors below 00:00-00:30 = 3 (third row in table).
    // That's why we add 3 to the 'from' index, and 2 to the 'to' index in the selectors.
    (blocking[days] || [])
        .map(interval => [interval.from, interval.to]
            .map(str => parseFloat(str.replace(':', '.')))
            .map(float => Math.floor(float) + Math.ceil(float))
        )
        .forEach(([from, to]) => $table
            .find(`tr:nth-of-type(n+${from + 3}):nth-of-type(-n+${to + 2})`)
            .find(`td:nth-of-type(${cols})`)
            .addClass('blocked')
        );
}

/**
 * Colors blocked cells in the table.
 * @param {jQuery} $table jQuery object for the schedule table
 */
function colorBlocked($table) {
    const blocking = JSON.parse($('#blocking').val());

    colorBlockedDays($table, blocking, 'mantor', '-n+4');
    colorBlockedDays($table, blocking, 'fre', '5');
    colorBlockedDays($table, blocking, 'lør', '6');
    colorBlockedDays($table, blocking, 'søn', '7');
}

/**
 * Colors selected cells in the table.
 * @param {jQuery} $table jQuery object for the schedule table
 * @param {jQuery} $schedule jQuery object for schedule input
 * @param {jQuery} $raaderum jQuery object for the råderum select
 * @param {jQuery} $afspaerring jQuery object for the afspærring select
 */
function colorSelected($table, $schedule, $raaderum, $afspaerring) {
    $table
        .find('td')
        .removeClass('selected')
        .find(CHECKBOXES)
        .prop('disabled', false)
        .prop('checked', false);
    $table
        .find('td.invalid input:checkbox')
        .prop('disabled', true);

    const schedule = $schedule.val();
    switch ($raaderum.val()) {
        case HELE_PERIODEN:
            $table.find('td:not(.invalid)').addClass('selected');
            $schedule.val("");
            showSelect($afspaerring);
            break;
        case SPECIFIKT_TIDSRUM:
            if (schedule && schedule.trim().length > 0) {
                const bitmask = convertHexStringToBitMask(schedule);
                $table
                    .find('td')
                    .filter((_, element) => bitmask[$(element).data('bit')])
                    .addClass('selected')
                    .find(CHECKBOXES)
                    .prop('checked', true);
            }
            hideSelect($afspaerring);
            break;
        case UDENFOR_SPAERRETID:
            $table.find('td:not(.invalid):not(.blocked)').addClass('selected');
            $schedule.val("");
            hideSelect($afspaerring);
            break;
        default:
            hideSelect($afspaerring);
    }
}

/**
 * Colors invalid cells in the table.
 * @param {jQuery} $table jQuery object for the schedule table
 */
function colorInvalid($table) {
    const fromDate = $('#fromDate').val();
    const fromTime = $('#fromTime').val();
    const toDate = $('#toDate').val();
    const toTime = $('#toTime').val();
    const from = moment(fromDate + ' ' + fromTime, ['DD-MM-YYYY hh:mm', 'YYYY-MM-DD hh:mm', 'DD/MM/YYYY hh:mm']);
    const to = moment(toDate + ' ' + toTime, ['DD-MM-YYYY hh:mm', 'YYYY-MM-DD hh:mm', 'DD/MM/YYYY hh:mm']);

    $table.find('td').removeClass('invalid');

    if (!from.isValid() || !to.isValid() || to.diff(from, 'weeks') >= 1) {
        return;
    }

    if (from.isSameOrAfter(to)) {
        $table.find('td').addClass('invalid');
        return;
    }

    const fromDay = from.weekday();
    const toDay = to.weekday();

    if (fromDay < toDay || (fromDay === toDay && fromTime < toTime)) {
        // Invalid is before from and after to
        $table.find('tr').find(`td:nth-of-type(-n+${fromDay})`).addClass('invalid'); // before from
        $table.find(`tr:nth-of-type(-n+${toRow(from) + 2})`).find(`td:nth-of-type(${fromDay + 1})`).addClass('invalid');
        $table.find(`tr:nth-of-type(n+${toRow(to) + 3})`).find(`td:nth-of-type(${toDay + 1})`).addClass('invalid');
        $table.find('tr').find(`td:nth-of-type(n+${toDay + 2})`).addClass('invalid'); // after to
        return;
    }

    if (fromDay > toDay) {
        // Invalid is between to and from, which are on different weekdays
        $table.find(`tr:nth-of-type(n+${toRow(to) + 3})`).find(`td:nth-of-type(${toDay + 1})`).addClass('invalid');
        $table.find('tr').find(`td:nth-of-type(n+${toDay + 2}):nth-of-type(-n+${fromDay})`).addClass('invalid');
        $table.find(`tr:nth-of-type(-n+${toRow(from) + 2})`).find(`td:nth-of-type(${fromDay + 1})`).addClass('invalid');
        return;
    }

    // Invalid is between to and from, on same weekday
    $table
        .find(`tr:nth-of-type(n+${toRow(to) + 3}):nth-of-type(-n+${toRow(from) + 2})`)
        .find(`td:nth-of-type(${fromDay + 1})`)
        .addClass('invalid');
}

function colorTable($table, $schedule, $raaderum, $afspaerring) {
    if ($table.length > 0) {
        colorBlocked($table);
        colorInvalid($table);
        colorSelected($table, $schedule, $raaderum, $afspaerring);
    }
}

function buildHexString($table) {
    const colCnt = 7;
    const bitmask = [];

    for (let i = 0; i < colCnt; i++) {
        $table
            .find(`td:nth-of-type(${i + 1})`)
            .find(CHECKBOXES)
            .each(function () {
                bitmask.push(this.checked ? 1 : 0);
            });
    }

    return bitmask.length === 0 ? '' :
        '2:' + bitmask
        .join('')
        .split(/(.{4})/)
        .filter(x=>x)
        .map(bits => parseInt(bits, 2).toString(16))
        .join('');
}

function handleSpecificPeriod($table, $schedule, $raaderum, $afspaerring) {
    hideSelect($afspaerring);
    $schedule.val(buildHexString($table));
    $raaderum.val(SPECIFIKT_TIDSRUM);
}

function onMouseDown(event) {
    event.preventDefault();
    let td = $(event.target).get(0);
    dragInitiator = td.id;
    if (td.tagName === 'TD') {
        if ($(td).hasClass('selected')) {
            selectState = 'deselect';
        } else {
            selectState = 'select';
        }
        originFromRowIndex = $(td).closest('tr').get(0).rowIndex;
        originFromColumnIndex = td.cellIndex;
        if (originFromRowIndex % 2 === 1) {
            originFromColumnIndex++;
        }
    } else {
        selectState = '';
    }
}

function onMouseUp(event, $table, $schedule, $raaderum, $afspaerring) {
    let td = $(event.target).get(0);
    const isInvalid = $(td).hasClass("invalid");
    if (dragInitiator === td.id) {
        if (!isInvalid) {
            $(td).toggleClass('selected');
        }
    }

    const $cells = $table.find('td');
    $cells.find('input').prop('checked', false);
    if (selectState === 'deselect') {
        $table.find('td.tempSelected').removeClass('selected');
    } else {
        $table.find('td.tempSelected').addClass('selected');
    }
    $cells.removeClass('tempSelected');
    $table.find('td.selected').find('input').prop('checked', true);
    handleSpecificPeriod($table, $schedule, $raaderum, $afspaerring);

    selectState = '';
    dragInitiator = '';
}

function onMouseEnter(event, $table) {
    if (event.buttons && selectState) {
        let toRowIndex = $(event.target).closest('tr').get(0).rowIndex;
        let toColumnIndex = $(event.target).closest('td').get(0).cellIndex;

        if (toRowIndex % 2 === 1) {
            toColumnIndex++;
        }

        let fromRowIndex = originFromRowIndex;
        let fromColumnIndex = originFromColumnIndex;

        if (fromRowIndex > toRowIndex) {
            [fromRowIndex, toRowIndex] = [toRowIndex, fromRowIndex];
        }

        if (fromColumnIndex > toColumnIndex) {
            [fromColumnIndex, toColumnIndex] = [toColumnIndex, fromColumnIndex];
        }

        $table.find('td').removeClass('tempSelected');
        $table
            .find(`tr:nth-of-type(n+${fromRowIndex + 1}):nth-of-type(-n+${toRowIndex + 1})`)
            .find(`td:nth-of-type(n+${fromColumnIndex}):nth-of-type(-n+${toColumnIndex}):not(.invalid)`)
            .addClass('tempSelected');
    }
}

// start: for use in confirmation modal
function schedule(s) {
    // temp fix if hex string is not set
    if (s === undefined || s === null) {
        return [];
    }

    const bitmap = convertToBitmap(s);
    let arrSchedules = [];
    let blockStart;
    let blockEnd = 0;
    let index = 0;

    while (index < bitmap.length && index >= 0) {
        if (bitmap[index] === 1) {
            blockStart = index;
            blockEnd = bitmap.indexOf(0, blockStart);
            blockEnd = blockEnd >= 0 ? blockEnd : bitmap.length;
            index = blockEnd;
            // fra
            let col = Math.floor(blockStart / 48);
            let row = blockStart % 48;
            const beforeStr = getDayAndTimeString(row, col);
            // til
            col = Math.floor(blockEnd / 48);
            row = blockEnd % 48;
            const afterStr = getDayAndTimeString(row, col);

            const scheduleText = '<p>' + beforeStr + ' til ' + afterStr + '</p>';

            arrSchedules.push(scheduleText);
        }
        index++;
    }
    return arrSchedules;
}

function getDayAndTimeString(row, col) {
    return `${ weekDays[col % 7] } ${ Math.floor(row / 2).toString().padStart(2, '0')  }:${ (row % 2 * 30).toString().padStart(2, '0') }`;
}

function convertToBitmap(str) {
    const digits = str.split(':')[1].split('');
    const bytes = [];

    for (const digit of digits) {
        const bits = parseInt(digit, 16).toString(2).padStart(4, '0');
        bytes.push(bits);
    }
    return bytes.join('').split('').map(Number);
}
// end: for use in confirmation modal

$(() => {
    const $table = $('#skoleskema');
    const $schedule = $('#schedule');
    const $raaderum = $('#raaderum');
    const $afspaerring = $('#afspaerring');
    const $cbHighContrast = $('#cbHighContrast');

    const highContrastCookie = $.cookie('highContrast') === 'true';

    $cbHighContrast.on('change', function (event) {
        const $tables = $('.skoleskema');
        const highContrast = $(event.currentTarget).prop('checked') === true;
        if (highContrast) {
            $tables.addClass('highContrast');
            $.cookie('highContrast', true);
        } else {
            $tables.removeClass('highContrast');
            $.cookie('highContrast', false);
        }
    });

    if (highContrastCookie) {
        $cbHighContrast.prop('checked', highContrastCookie).change();
    }

    colorTable($table, $schedule, $raaderum, $afspaerring);

    $table
        .on('mousedown', 'td', event => onMouseDown(event))
        .on('mouseup', 'td', event => onMouseUp(event, $table, $schedule, $raaderum, $afspaerring))
        .on('mouseenter', 'td', event => onMouseEnter(event, $table))
        .on('change', CHECKBOXES, function (event) {
            if ($raaderum.val() !== SPECIFIKT_TIDSRUM) {
                $raaderum.val(SPECIFIKT_TIDSRUM);
            }
            $(event.target).prop("checked") ?
                $(event.target).closest('td').addClass("selected") :
                $(event.target).closest('td').removeClass("selected");
            handleSpecificPeriod($table, $schedule, $raaderum, $afspaerring);
        })
        .on('focus', CHECKBOXES, function (event) {
            $(event.target).closest('td').addClass("hover");
        })
        .on('blur', CHECKBOXES, function (event) {
            $(event.target).closest('td').removeClass("hover");
        });

    $('#fromDate, #fromTime, #toDate, #toTime')
        .on('change', () => colorTable($table, $schedule, $raaderum, $afspaerring));
    $raaderum
        .on('change', () => colorSelected($table, $schedule, $raaderum, $afspaerring));
    $afspaerring
        .on('change', () => $table.toggleClass('periodic', $afspaerring.val() === PERIODEVIS));

    $table.on('mouseleave', function () {
        $table.find('td').removeClass('tempSelected');
        $table.focus();
    });

    // ============================================================================================
    // confirmation modal
    // ============================================================================================
    const $modal = $('#acceptWhenModal');

    if ($modal.is(':visible')) {
        const sche = $schedule.val();
        if (sche && sche.trim().length > 0) {
            $('#allSchedules').html(schedule(sche));
        }

        $modal.get(0).addEventListener('fds.modal.hidden', () => {
            $('#accepted').prop('checked', false);
        });
    }
});
